
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/multicomplete/templates/suggestions_phone"] = Handlebars.template({"0":function(container,depth0,helpers,partials,data) {
    return "<footer id='suggestions_footer'>\n  <div class='without_query'>\n    Search for a member of this workspace by name\n  </div>\n  <div class='with_query'>\n    <span>Is the person you're looking for not listed?</span>\n    <span>They may not be in this workspace, or have no phone number stored.</span>\n  </div>\n</footer>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<ul id='suggestions'></ul>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"show_footer") : depth0),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":12,"column":7}}})) != null ? stack1 : "");
},"useData":true});
    }).call(this);
  